import { FC, useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

import { useGetUserProfileQuery } from '../../../api/combined'
import { RoleEnum } from '../../../features/account'
import { useRoleCheck } from '../../../features/account/hooks/roleHooks'

type InternalRolesRouteProps = {
  roles: RoleEnum[]
}

/**
 * Renders the nested internal routes only for users with all given roles and sends others to the internal home page
 */
export const InternalRolesRoute: FC<InternalRolesRouteProps> = ({ roles }) => {
  const navigate = useNavigate()
  const { isSuccess: isProfileLoaded } = useGetUserProfileQuery()
  const hasAccess = useRoleCheck(roles)

  useEffect(() => {
    if (isProfileLoaded && !hasAccess) {
      navigate('/internal', { replace: true })
    }
  }, [hasAccess, isProfileLoaded, navigate])

  return hasAccess ? <Outlet /> : null
}
